module.exports = __webpack_public_path__ + "static/media/right-arrow.a1d370cc.svg";